import React from "react";
import { Box } from "@mui/material";
import RegistationComponent from "../organisms/RegistationComponent";
import ConfirmationModal from "../organisms/ConfirmationModal";

export default function RecruitmentRegisterTemplate() {
  return (
    <Box>
      <RegistationComponent />
      <ConfirmationModal />
    </Box>
  );
}